var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"modal-overlay",on:{"click":_vm.close}},[_c('div',{staticClass:"modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('button',{staticClass:"close-button",on:{"click":_vm.close}},[_vm._v("✕")]),_c('iframe',{staticClass:"pdf-viewer",attrs:{"src":_vm.pdfUrl}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }